import { useEffect, useState } from "react";
export function useIsDesktop(breakpoint = 768) {
    const [isLarge, setIsLarge] = useState(() => window.innerWidth >= breakpoint);
    useEffect(() => {
        function handleResize() {
            setIsLarge(window.innerWidth >= breakpoint);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);
    return isLarge;
}
